







import Header from "./Header.vue";
import HeaderView from "./HeaderView.vue";

export default  {
  props: {
    components: {
      type: Object,
      default() {
        return {
          Header,
          HeaderView
        };
      }
    }
  }
}
